var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsarLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#0CA7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 27L23.75 29H13C12.45 29 11.9792 28.8042 11.5875 28.4125C11.1958 28.0208 11 27.55 11 27V11C11 10.45 11.1958 9.97917 11.5875 9.5875C11.9792 9.19583 12.45 9 13 9H22L27 15V27C27 27.3333 26.9292 27.6375 26.7875 27.9125C26.6458 28.1875 26.45 28.4167 26.2 28.6L21 23.45C20.7167 23.6333 20.4083 23.7708 20.075 23.8625C19.7417 23.9542 19.3833 24 19 24C17.9 24 16.9583 23.6083 16.175 22.825C15.3917 22.0417 15 21.1 15 20C15 18.9 15.3917 17.9583 16.175 17.175C16.9583 16.3917 17.9 16 19 16C20.1 16 21.0417 16.3917 21.825 17.175C22.6083 17.9583 23 18.9 23 20C23 20.3833 22.9542 20.7417 22.8625 21.075C22.7708 21.4083 22.6333 21.7167 22.45 22L25 24.6V15.7L21.05 11H13V27H21.75ZM19 22C19.55 22 20.0208 21.8042 20.4125 21.4125C20.8042 21.0208 21 20.55 21 20C21 19.45 20.8042 18.9792 20.4125 18.5875C20.0208 18.1958 19.55 18 19 18C18.45 18 17.9792 18.1958 17.5875 18.5875C17.1958 18.9792 17 19.45 17 20C17 20.55 17.1958 21.0208 17.5875 21.4125C17.9792 21.8042 18.45 22 19 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsarLetter);
export default __webpack_public_path__ + "static/media/dsar-letter.665f3c5b1be16656de47cc1a1d3bcadc.svg";
export { ForwardRef as ReactComponent };